import * as z from "zod";

import { RawDateOnlySchema } from "@app/shared/schemas/date";

export const InstallmentSchema = z.object({
  Number: z.int().min(0),
  DueAt: RawDateOnlySchema.nullable(),
  ExpireAt: RawDateOnlySchema.nullable(),
  Fee: z.int().min(0).nullable(),
  FeeType: z.string().nullable(),
  InstallmentValue: z.int().min(0),
  FinalAmount: z.int().min(0),
});
